import { FC, ReactNode } from 'react';
import { IHistoryProgress } from './agencyDigest';
import { describeHistoryWait } from './agencyNarration';
import { HistoryWaitNote } from './HistoryWaitNote';

/** A panel's figures once the caseload has the history they compare against, and until then what it is waiting for. */
export const NeedsHistory: FC<{
    history: IHistoryProgress;
    /** Which panel this stands in for, so a driver can select one without counting from the top. */
    panel: string;
    children: ReactNode;
}> = ({ history, panel, children }) => {
    if (history.hasEnough) {
        return <>{children}</>;
    }

    return <HistoryWaitNote panel={panel}>{describeHistoryWait(history)}</HistoryWaitNote>;
};
